import React from 'react'
import bg from './imageSrc/blue_background.png'
import slogon from './imageSrc/xzslogon.png'
import {browserHistory, Link} from 'react-router'
import PropTypes from 'prop-types'
import './loginPage.css'
import MD5 from 'md5'
import axios from 'axios'
import '../config'
import Base64 from 'base-64'
import EditPad from "./editPage";
import {convert_FormData_to_json2} from "../config";
import {message} from 'antd'
import './utils/fetchData';
import {fetchGet, fetchPost} from "./utils/fetchData";
import {showErrorMsg} from "./utils/commonFunc";

class LoginPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            getMCodeBtnTitle : '获取验证码',   //获取短信验证码按钮的文案展示
            serialNo : '',//流水号
            loginStyle : 'pwd_login',//密码登录
            showComfirm : 'none',  //密码确认输入框
            showPwdInput : 'inline',//刚开始要展示密码输入框
            showSmsCode : 'inline', //验证码按钮展示不展示
            getSmsCodeDisplay : 'none', //获取验证码按钮刚开始不展示
            showSmsCodeInput : 'none',//刚开始不展示输入短信验证码的框
            pwdInputMarginTop : 2 + '%',//刚开始密码输入框的上边距
            loginBtnTitle : '提交',   //提交按钮
            showPwdMention:'none',   //密码输入提示
            timeCounting:60,                //获取验证码倒计时
            STR:'appid=test&appsercet=123456&nonce=jsdfeijklsfj&timestamp=',
            mobileCodeTimer:null,           //获取验证码倒计时
            mobileCodeBtnClickable:false,   //获取验证码之后禁止再次点击
            hasAccountText:'没有账号?',       //登录页面最底下的注册文案
            registerText:'立即注册',         //登录页面最底下的注册文案
            showBackToPwdLogin:'none',       //是否展示返回密码登录
            showTip: 'none',
            tipTxt: '',
        };
    }

    componentWillMount() {
        let timeStamp = Date.parse(new Date()).toString().substring(0,10);
        let params = {appid:'test',nonce:'jsdfeijklsfj',timestamp:timeStamp.toString(),sign:this.getSTR().toString()};
        let data = fetchGet('token',params,null);
        data.then(data => {
            if (data.code === 200) {
                global.constants.token = data.data.access_token;
                global.constants.authentication = Base64.encode('test'+':'+data.data.access_token);
                localStorage.setItem('authentication',Base64.encode('test'+':'+data.data.access_token));
            } else {
                this.showError(data.message);
            }
        })
    }

    componentWillUnmount() {
        this.clearTimer();
    }

    clearTimer = () => {
        if (this.state.mobileCodeTimer != null) {
            clearInterval(this.state.mobileCodeTimer);
        }
    }

    static contextTypes = {
        router: PropTypes.object
    };

    getSTR = ()=> {
        let retStr = this.state.STR;
        let timeStamp = Date.parse(new Date()).toString().substring(0,10);
        return MD5(retStr.concat(timeStamp));
    };

    showComfirmInput = ()=> {
        if (this.state.loginBtnTitle === '注册') {
            this.changeToLoginType();
            this.setState({
                hasAccountText:'没有账号?',
                registerText:'立即注册',
            });
        } else {
            this.changeToRegisterType();
            this.setState({
                hasAccountText:'已有账号?',
                registerText:'立即登录',
            });
        }
    };

    changeToRegisterType = () => {
        this.setState({
            showComfirm:'block',
            showSmsCode:'none',
            getSmsCodeDisplay:'inline',
            showSmsCodeInput:'inline',
            loginBtnTitle:'注册',
            showPwdInput : 'inline',
            showPwdMention : 'block',
            pwdInputMarginTop : 0 + '%',
            loginStyle:'sms_code',
            showBackToPwdLogin:'none',
        })
    };

    showError = (errMsg) => {
        message.error(errMsg);
    };

    showSuccess = (successMsg) => {
        message.success(successMsg);
    };

    getMobileCode = () => {
        if (this.state.loginStyle === 'sms_code') {
            var that = this;

            let formData = new FormData();
            formData.append("mobile", this.refs.mobileNo.value);
            if (this.state.loginBtnTitle === '注册') {
                formData.append("type", 1);
            } else {
                formData.append("type", 2);
            }

            let retValue = fetchPost('mobile',convert_FormData_to_json2(formData),null);
            retValue.then(data => {
                console.log(data.code);
                if (data.code === 200) {
                    that.showSuccess('获取验证码成功');
                    that.setState({
                        loginStyle:'sms_code',
                        serialNo:data.data.seria_no,
                    })


                    if (this.state.timeCounting > 0) {
                        that.state.mobileCodeTimer=setInterval(()=>{
                            let timeCounter = --this.state.timeCounting;
                            if (timeCounter > 0) {
                                that.setState({
                                    getMCodeBtnTitle:timeCounter,
                                    mobileCodeBtnClickable:true,
                                    timeCounting:timeCounter,
                                })
                            }else {
                                that.clearTimer();
                                that.setState({
                                    getMCodeBtnTitle:'获取验证码',
                                    mobileCodeBtnClickable:false,
                                    timeCounting:60,
                                })
                            }
                        }, 1000)
                    }
                }
                else {
                    showErrorMsg(data);
                    
                    var tip = '';
                    if (data.code === 400) {
                        tip = data.data.info;
                    } else {
                        tip = data.message;
                    }

                    that.setState({
                        showTip: 'block',
                        tipTxt: tip,
                    })

                }
            })
        } else {

            this.setState({
                loginStyle:'sms_code',
                showSmsCode:'none',
                getSmsCodeDisplay:'inline',
                showSmsCodeInput:'inline',
                showPwdInput:'none',
                showBackToPwdLogin:'inline-block'
            })
        }
    };

    //返回到登录
    changeToLoginType = () => {
        this.setState({
            showComfirm:'none',
            showSmsCode:'inline',
            getSmsCodeDisplay:'none',
            showSmsCodeInput:'none',
            loginBtnTitle:'登录',
            showPwdInput : 'inline',
            showPwdMention : 'none',
            pwdInputMarginTop : 2 + '%',
            loginStyle:'pwd_login',
            showBackToPwdLogin:'none',
            showTip: 'none',
        })
    };

    redirect = (event)=>{
        // this.context.router.push('editPage');
        var that = this;
        let header = new Headers({
            'Accept': 'application/json',
            "Content-Type": "application/json",
        });
        if (global.constants.authentication != null) {
            header.append('authentication','TOKEN ' + global.constants.authentication);
        }
        if (this.state.loginBtnTitle === '注册') {
            let mobile = this.refs.mobileNo.value;
            let mobile_Code = this.refs.mobileCode.value;

            let formData = new FormData();
            formData.append("mobile", mobile);
            formData.append('code',mobile_Code);
            formData.append('seria_no',this.state.serialNo);
            formData.append("password", MD5(this.refs.password.value));

            let retData = fetchPost('register',convert_FormData_to_json2(formData),null);
            retData.then(data => {
                    if (data.code === 200) {
                        localStorage.setItem('loginusertoken',data.data.lguser_token);
                        global.constants.loginusertoken = data.data.lguser_token;
                        that.context.router.push('editPage');
                    } else {
                        showErrorMsg(data);
                    }
                })
        } else {
            let formData = new FormData();
            let mobile_code = this.refs.mobileCode.value;
            let func;
            if (this.state.loginStyle === 'pwd_login') {
                formData.append("mobile", this.refs.mobileNo.value);
                formData.append("password", MD5(this.refs.password.value));
                func = 'login';
            } else if (this.state.loginStyle === 'sms_code') {
                formData.append("mobile", this.refs.mobileNo.value);
                formData.append("code", mobile_code);
                formData.append("seria_no", this.state.serialNo);
                func = 'loginSms';
            }

            let dataRet = fetchPost(func,convert_FormData_to_json2(formData) ,null)
            dataRet.then(data => {
                if (data.code === 200) {
                    global.loginUser = data.data;
                    localStorage.setItem('loginusertoken',global.loginUser.lguser_token);
                    localStorage.setItem('nickName',global.loginUser.lguser_nickname);
                    global.constants.loginusertoken = global.loginUser.lguser_token;
                    that.context.router.push('editPage');
                } else {
                   showErrorMsg(data);
                }
            })
        }

    };
    render() {
        return(
            <div className='backPage'>
                <div className='background_img'>
                    <img src={bg} className='bg_img'/>
                </div>

                <div className='div_input'>
                    <img src={slogon} style={{width: 240 + 'px',height:240 + 'px',marginTop:0 + 'px'}}/>
                    <form action="form_action.asp" method="get">
                        <input ref='mobileNo' type="text" placeholder={'输入您的手机号'} className='inlineStyle'/>
                        <br/>
                        <div className='tip_div' style={{display:this.state.showTip}}>
                            <span className='tip_error'>{this.state.tipTxt}</span>
                        </div>
                        
                        <br/>
                        <input ref='mobileCode' style={{display:this.state.showSmsCodeInput}} type="text" placeholder={'输入短信验证码'} className='input_mobileCode'/>
                        <button  type={'button'}
                                 disabled={this.state.mobileCodeBtnClickable}
                                 className='code_btn_style'
                                 onClick={this.getMobileCode}
                                 style={{display:this.state.getSmsCodeDisplay}}>{this.state.getMCodeBtnTitle}</button>

                        <span style={{display:this.state.showPwdMention}}
                              className='pwd_mention'>请设置8~16位密码，包含数字和大小写</span>

                        <input ref='password'
                               type="password"
                               placeholder={'输入您的密码'}
                               className='inlineStyle'
                               style={{marginTop:this.state.pwdInputMarginTop,display:this.state.showPwdInput}}/>

                        <button  type={'button'}
                                 className='code_btn_style'
                                 onClick={this.getMobileCode}
                                 style={{display:this.state.showSmsCode}}>验证码登录</button>
                        <br/>
                        <a href='javascript:;' onClick={this.changeToLoginType} style={{marginLeft:10 + 'px', fontSize:'10px',verticalAlign:'bottom',display:this.state.showBackToPwdLogin}}>返回密码登录</a>
                        <input ref='comfirmInput'
                               type="password"
                               placeholder={'确认您的密码'}
                               className='inlineStyle_pwd'
                               style={{display:this.state.showComfirm}}/>
                        <br/>
                        <button type={'button'} className='code_btn_style' style={{marginLeft:0 + 'px',marginTop:3 + '%', display:'inline-block'}} onClick={this.redirect}>{this.state.loginBtnTitle}</button>
                        <span style={{whiteSpace:'nowrap',fontSize:'10px',verticalAlign:'bottom',marginLeft:'10px',display:'inline-block'}}>{this.state.hasAccountText}<a onClick={this.showComfirmInput} href='javascript:;' style={{fontSize:'10px',verticalAlign:'bottom'}}>{this.state.registerText}</a></span>
                    </form>
                </div>
            </div>

        );
    }
}

// LoginPage.propTypes = {
//     serialNo: PropTypes.string, //loading的内容展示
//     // time: PropTypes.number, //隐藏loading的时间间隔
//     // isHide: PropTypes.bool, //是否隐藏loading
//     // state: PropTypes.oneOf(['success', 'fail', 'loading']), //标记要显示的图片
//     // onCallBack: PropTypes.func //loading隐藏后的回调处理函数
// };
//
// LoginPage.defaultProps = {
//     serialNo: '',
// };

export default LoginPage;